'use strict';

const BookPresenter = require('../presenters/book');

const BaseView = require('./base');

class BookView extends BaseView {
  initialize() {
    this.setModule('glive_booking_redesign');
    this.presenter = BookPresenter;
    this.templateName = 'book';
  }

  attributes() {
    return { isTouch: this.model ? this.model.get('isTouch') : undefined };
  }

  _disableButton() {
    $(this.el)
      .find('button.disabled')
      .click(e => e.preventDefault());
  }
}

module.exports = BookView;
